import { memo } from "react";
import { AtcAccordionItem } from "@/components/meds/atc/atc-list/atc-accordion/atc-accordion-item";
import { AtcAccordionProvider } from "@/components/meds/atc/atc-list/atc-accordion/atc-accordion-context";
import { useAtcKeyboardExpandAll } from "../atc-keyboard-shortcuts";

export const AtcAccordionInner = memo(function AtcAccordionInner({
  items,
  onSelect,
  onLeafSelect,
}: {
  items: AtcItem[];
  onSelect?: (item: AtcItem) => void;
  onLeafSelect?: (item: AtcItem) => void;
}) {
  useAtcKeyboardExpandAll(items);

  return (
    <div className={"w-full"}>
      {items.map((item) => (
        <AtcAccordionItem
          key={item.code}
          item={item}
          depth={0}
          onSelect={onSelect}
          onLeafSelect={onLeafSelect}
        />
      ))}
    </div>
  );
});

export const AtcAccordion = memo(function AtcAccordion({
  items,
  onSelect,
  onLeafSelect,
  initialExpandedIds,
}: {
  items: AtcItem[];
  onSelect?: (item: AtcItem) => void;
  onLeafSelect?: (item: AtcItem) => void;
  initialExpandedIds?: Set<string>;
}) {
  return (
    <AtcAccordionProvider items={items} initialExpandedIds={initialExpandedIds}>
      <AtcAccordionInner
        items={items}
        onSelect={onSelect}
        onLeafSelect={onLeafSelect}
      />
    </AtcAccordionProvider>
  );
});
